import { render, staticRenderFns } from "./App5StackedBar.vue?vue&type=template&id=61e43a98&"
import script from "./App5StackedBar.vue?vue&type=script&lang=js&"
export * from "./App5StackedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports